export default {
  // masterAccounts: [],
  accountData: [],
  accountDataFilters: {
    Master_Id: null,
    Customer_Id: null,
    Acct_ID: null,
    Acct_Name: null,
    Acct_DL: null,
    MP_ID: null,
    Agreement: 'all',
    Acct_Status: ['New', 'ACTIVE'],
    deleted: '0',
    archived: '0',
    Customer_Owned: 'No'
  },
  nextPaginationKey: '',
  loadingAccountData: false,
  masterPayers: [],
  pods: [],
  customerAccounts: [],
  loadingCustomerAccounts: false,
  downloadingAccount: false,
  accountAgreementFilter: 'all',
  deleteFlag: {
    Acct_ID: 'null',
    Acct_Exp_Id: 'null',
    Financial_Id: 'null',
    Unique_Agreement_Id: 'null',
    Customer_Id: 'null',
    Registration_Id: 'null',
    Acct_name: 'null',
    Acct_DL: 'null',
    Date_onboarded: 'null',
    Last_Date_Validated: 'null',
    Date_Suspended: 'null',
    Date_Requested_change: 'null',
    MP_ID: 'null',
    Previous_MP_ID: 'null',
    Managed_Svc: 'null',
    Acct_status: 'None',
    Is_MP: 'Yes',
    Acct_Description: 'None',
    Del_Flag: '0',
    GovCloud_Account_Number: 'null'
  },
  selectedAgreement: '',
  customersList: [],
  breadcrumbs: [
    {
      text: 'Customer',
      disabled: false,
      href: '/admin/account-inventory/customers'
    },
    {
      text: '',
      disabled: true,
      href: ''
    }],
  customerType: ['DXC_Internal', 'External'],
  awsSupportType: ['Enterprise', 'Business', 'Developer', 'Basic', 'Enterprise Support', 'Business Support+', 'Basic Support'],
  // regions: ['All Region', 'AMS', 'ANZ', 'Asia', 'NCE', 'SE', 'UKIIEMEA'],
  regions: ['Americas', 'UKI', 'Europe', 'APJ-MEA', 'Luxoft'],
  acctStatus: ['New', 'Pending', 'NA'],
  // Todo: this should be dynamic once api provides the ff data
  accountHeaders: [
    {
      sortable: false,
      text: 'Actions',
      value: 'Actions',
      align: 'left'
    },
    {
      sortable: false,
      text: 'OppReg Id',
      value: 'OppReg_Id',
      align: 'left'
    },
    {
      sortable: false,
      text: 'ACE Opportunity Number',
      value: 'ACE_Opportunity_Number',
      align: 'left'
    },
    {
      sortable: false,
      text: 'AWS EUR Date',
      value: 'AWS_EUR_Date',
      align: 'left'
    },
    {
      sortable: false,
      text: 'AWS ACE Launch Date',
      value: 'AWS_ACE_Launch_Date',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Account Name',
      value: 'Acct_name',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Account Status',
      value: 'Acct_Status',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Account Group',
      value: 'Acct_Alias_Group',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Account Offering Status',
      value: 'Acct_Offering_Stat',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Account DL',
      value: 'Acct_DL',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Account ID',
      value: 'Acct_ID'
    },
    {
      sortable: false,
      text: 'Account Status',
      value: 'Acct_status',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Account Description',
      value: 'Acct_Description',
      align: 'left'
    },
    {
      sortable: false,
      text: 'AWS Support Type',
      value: 'AWS_Support_Type',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Account Expire On Credits',
      value: 'Account_expire_on_credits',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Account Expire On End Date',
      value: 'Account_expire_on_end_date',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Account Notes',
      value: 'Account_notes',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Client Discount',
      value: 'Client_discount',
      align: 'left'
    },
    {
      sortable: false,
      text: 'MP Uplift',
      value: 'MP_uplift'
    },
    {
      sortable: false,
      text: 'Client Uplift',
      value: 'Client_uplift',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Contract Description',
      value: 'Contract_description',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Credit Amount',
      value: 'Credit_Amount',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Customer Name',
      value: 'Customer_Name',
      align: 'left'
    },
    // {
    //   text: 'Customer Alias Group',
    //   value: 'Customer_Alias_Group',
    //   align: 'left'
    // },
    {
      sortable: false,
      text: 'Customer Region',
      value: 'Customer_Region',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Customer Type',
      value: 'Customer_Type',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Account Restricted',
      value: 'Acct_Restricted'
    },
    {
      sortable: false,
      text: 'MFA',
      value: 'MFA'
    },
    {
      sortable: false,
      text: 'Root Credential Store',
      value: 'Root_Credential_Store'
    },
    {
      sortable: false,
      text: 'DXC discount',
      value: 'DXC_discount',
      align: 'left'
    },
    {
      sortable: false,
      text: 'DXC uplift',
      value: 'DXC_uplift',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Date Requested change',
      value: 'Date_Requested_change',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Date onboarded',
      value: 'Date_onboarded',
      align: 'left'
    },
    {
      sortable: false,
      text: 'End date',
      value: 'End_date',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Ext Account Id',
      value: 'Ext_Account_Id',
      align: 'left'
    },
    {
      sortable: false,
      text: 'IWO Code',
      value: 'IWO_Code',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Comments',
      value: 'Comments',
      align: 'left'
    },
    {
      sortable: false,
      text: 'AWS Usage Type',
      value: 'AWS_Usage_Type',
      align: 'left'
    },
    {
      sortable: false,
      text: 'AWS Government Customer',
      value: 'AWS_Government_Customer',
      align: 'left'
    },
    {
      sortable: false,
      text: 'AWS Advising Government',
      value: 'AWS_Advising_Government',
      align: 'left'
    },
    {
      sortable: false,
      text: 'GovCloud Resource Account',
      value: 'GovCloud_Resource_Account',
      align: 'left'
    },
    {
      sortable: false,
      text: 'IWO Reqd',
      value: 'IWO_Reqd',
      align: 'left'
    },
    {
      sortable: false,
      text: 'IWO expiration date',
      value: 'IWO_expiration_date',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Is MP',
      value: 'Is_MP',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Last Date Validated',
      value: 'Last_Date_Validated',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Date Suspended',
      value: 'Date_Suspended',
      align: 'left'
    },
    {
      sortable: false,
      text: 'MP ID',
      value: 'MP_ID',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Marked as Unknown MP',
      value: 'DateMarkedAsUnknown',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Managed Svc',
      value: 'Managed_Svc',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Onboard Id',
      value: 'Onboard_Id',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Previous MP ID',
      value: 'Previous_MP_ID',
      align: 'left'
    },
    {
      sortable: false,
      text: 'R Code',
      value: 'R_Code',
      align: 'left'
    },
    {
      sortable: false,
      text: 'Registration Id',
      value: 'Registration_Id',
      align: 'left'
    },
    {
      sortable: false,
      text: 'WBS code',
      value: 'WBS_code',
      align: 'left',
      width: '30%'
    },
    {
      sortable: false,
      text: 'WBS expiration date',
      value: 'WBS_expiration_date',
      align: 'left'
    }
  ],
  customers: [],
  customerHeaders: [
    {
      sortable: false,
      text: 'Customer',
      value: 'Customer_Name'
    },
    {
      sortable: false,
      text: '# of Accounts',
      value: 'No_of_Accts'
    }
  ],

  customerListHeaders: [
    {
      sortable: false,
      text: 'Actions',
      value: ''
    },
    {
      sortable: false,
      text: 'OppReg Id',
      value: 'OppReg_Id'
    },
    {
      sortable: false,
      text: 'ACE Opportunity Number',
      value: 'ACE_Opportunity_Number'
    },
    {
      sortable: false,
      text: 'Account Name',
      value: 'Acct_name'
    },
    {
      sortable: false,
      text: 'Account Status',
      value: 'Acct_Status'
    },
    {
      sortable: false,
      text: 'Account DL',
      value: 'Acct_DL'
    },
    {
      sortable: false,
      text: 'Account ID',
      value: 'Acct_ID'
    },
    {
      sortable: false,
      text: 'Date Onboarded',
      value: 'Date_onboarded'
    },
    {
      sortable: false,
      text: 'Last Date Validated',
      value: 'Last_Date_Validated'
    },
    {
      sortable: false,
      text: 'Date Suspended',
      value: 'Date_Suspended'
    },
    {
      sortable: false,
      text: 'MP_ID',
      value: 'MP_ID'
    },
    {
      sortable: false,
      text: 'Previous MP ID',
      value: 'Previous_MP_ID'
    },
    {
      sortable: false,
      text: 'Customer Name',
      value: 'Customer_Name'
    },
    {
      sortable: false,
      text: 'Managed Service',
      value: 'Managed_Svc'
    },
    {
      sortable: false,
      text: 'AWS Support Type',
      value: 'AWS_Support_Type'
    },
    {
      sortable: false,
      text: 'Customer Region',
      value: 'Customer_Region'
    }, {
      sortable: false,
      text: 'Account Restricted',
      value: 'Acct_Restricted'
    },
    {
      sortable: false,
      text: 'MFA',
      value: 'MFA'
    },
    {
      sortable: false,
      text: 'Root Credential Store',
      value: 'Root_Credential_Store'
    },
    {
      sortable: false,
      text: 'DXC Discount',
      value: 'DXC_discount'
    },
    {
      sortable: false,
      text: 'Client Discount',
      value: 'Client_discount'
    },
    {
      sortable: false,
      text: 'MP Uplift',
      value: 'MP_uplift'
    },
    {
      sortable: false,
      text: 'Client Uplift',
      value: 'Client_uplift'
    },
    {
      sortable: false,
      text: 'WBS Code',
      value: 'WBS_code'
    },
    {
      sortable: false,
      text: 'IWO Code',
      value: 'IWO_Code'
    },
    {
      sortable: false,
      text: 'Comments',
      value: 'Comments'
    }
  ],
  // customersList: [
  //   {
  //     Ext_Account_Id: null,
  //     Acct_name: null,
  //     Acct_DL: null,
  //     Acct_ID: null,
  //     Date_onboarded: null,
  //     Last_Date_Validated: null,
  //     MP_ID: null,

  //     Previous_MP_ID: null,
  //     Customer_Name: null,
  //     Managed_Svc: null,
  //     AWS_Support_Type: null,
  //     Customer_Region: null,
  //     Acct_Restricted: null,

  //     MFA: null,
  //     DXC_discount: null,
  //     Client_discount: null,
  //     MP_uplift: null,
  //     Client_uplift: null,
  //     WBS_code: null,
  //     IWO_Code: null
  //   }
  // ],
  byLinkedHeaders: [
    {
      sortable: false,
      text: 'Account ID',
      value: 'Acct_ID'
    },
    {
      sortable: false,
      text: 'Account Name',
      value: 'Acct_name'
    }],
  adminListHeaders: [
    {
      sortable: false,
      text: 'Actions',
      value: ''
    },
    {
      sortable: false,
      text: 'Opportunity ID',
      value: 'SFDC_Id'
    },

    // WORKLOAD DATA
    {
      sortable: false,
      text: 'Workload Title',
      value: 'Workload_Title'
    },
    {
      sortable: false,
      text: 'OppReg Req Date',
      value: 'OppReg_Req_Date'
    },
    {
      sortable: false,
      text: 'Workload Status',
      value: 'Workload_Status'
    }
  ],
  adminList: [
    {
      SFDC_ID: 'test',
      SFDC_Oppty_Name: 'test',
      Customer_Name: 'test',
      ESRegion: 'test',
      Customer_Address: 'test',
      Customer_City: 'test',
      Country: 'test',
      Customer_State: 'test',
      Customer_PC: 'test',
      Customer_URL: 'test',
      Contact_First_Name: 'test',
      Contact_Last_Name: 'test',
      Contact_Email: 'test',
      Contact_Phone: 'test',
      RFI_RFP: 'test',
      Workload_Title: 'test',
      Workload_Services_Storage: 'test',
      Workload_Services_Database: 'test',
      Workload_Services_App_services: 'test',
      Workload_Services_Compute: 'test',
      Workload_Services_Network: 'test',
      Projected_Monthly_Spend: 'test',
      WL_Overall_Objective: 'test',
      WL_Scope_Bounderies: 'test',
      WL_App_Transformed: 'test',
      WL_Next_Pursuit: 'test'
    }
  ],
  selectedAccounts: [],
  selected: [],
  // acctStatusFilter: ['New', 'ACTIVE', 'SUSPENDED', 'Moved to Client'],
  acctStatusFilter: [
    {
      text: 'New',
      value: 'New'
    },
    {
      text: 'Active',
      value: 'ACTIVE'
    },
    {
      text: 'Suspended',
      value: 'SUSPENDED'
    },
    {
      text: 'Moved to Client',
      value: 'Moved to Client'
    },
    {
      text: 'Active - Not in Use',
      value: 'Active - Not in Use'
    }
  ],
  acctMiscFilter: [
    {
      text: 'UNKNOWN',
      value: 'UNKNOWN'
    },
    {
      text: 'Deleted',
      value: 'Deleted'
    },
    {
      text: 'Archived',
      value: 'Archived'
    }
  ],
  selectedAcctStatus: null,
  archivedAcctStatus: null,
  lastDateValidatedStatus: false,
  attestationReportHeaders: [
    {
      sortable: false,
      text: 'Master Payer',
      value: 'master_payer'
    },
    {
      sortable: false,
      text: 'New Accounts this Quarter',
      value: 'new_accounts'
    },
    {
      sortable: false,
      text: 'Current Active',
      value: 'current_active'
    },
    {
      sortable: false,
      text: 'Last Quarter end Active',
      value: 'last_qtr_active'
    },
    {
      sortable: false,
      text: 'Suspended this Quarter',
      value: 'suspended'
    },
    // {
    //   sortable: false,
    //   text: 'Reported Count',
    //   value: 'reported_count'
    // },
    {
      sortable: false,
      text: 'Number of accounts left the org(active) this Quarter',
      value: 'active_accounts_left'
    },
    {
      sortable: false,
      text: 'Number of accounts left the org(suspended) > 90 days',
      value: 'suspended_accounts_left'
    }
  ],
  attestationReport: {
    selectedQtr: 0,
    filters: {}
  }
}
